import { DatePicker, InputNumber } from 'antd';
import Title from 'antd/es/typography/Title';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

const { RangePicker } = DatePicker;

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;

export const StyledRangePicker = styled(RangePicker)`
  width: 100%;

  .ant-picker-suffix,
  .ant-picker-suffix .anticon,
  .ant-picker-range-separator,
  .ant-picker-range-separator .anticon {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.85) !important;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;

  .ant-picker-suffix,
  .ant-picker-suffix .anticon {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.85) !important;
  }
`;

export const StyledTitle = styled(Title)`
  &.ant-typography {
    font-weight: 400;
    margin-top: 16px;
    margin-bottom: 16px;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;
  }
`;

export const TradingDealHint = styled.div`
  margin-bottom: 16px;
  color: ${APP_SHELL_THEME.textMuted};
  font-size: 14px;
  line-height: 1.5;
`;
